/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Image } from 'react-bootstrap';
import * as S from './styles';
import { ArrowLeftIcon } from '@heroicons/react/solid';
import { useBreakpoint } from '@vlinder-web/breakpoint-hook-widget-react';
export interface IImageOverlayProps {
  imageStyle: any;
  src: string;
  overlaySrc?: string;
}

export const ImageOverlay = ({
  imageStyle,
  src,
  overlaySrc,
}: IImageOverlayProps) => {
  const breakpoint = useBreakpoint();
  const _renderOverlayImageIf = () => {
    if (overlaySrc) {
      return <Image src={overlaySrc} style={S.Icon} />;
    }
  };
  const _getImageHeight = () => {
    let _style: any = {
      height: '',
    };
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      _style.height = '70vw';
    }
    return _style;
  };
  return (
    <>
      <div
        style={
          (S.ImageContainer,
          {
            height: breakpoint === 'xs' || breakpoint === 'sm' ? '100%' : '',
          })
        }
      >
        <Image src={src} style={{ ...S.Image, ...imageStyle }} />
        {_renderOverlayImageIf()}
      </div>
    </>
  );
};

ImageOverlay.defaultProps = {
  imageStyle: {},
};
